const DAY_NAMES = ['日', '月', '火', '水', '木', '金', '土'];

export function formatDateJa(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const dayOfWeek = DAY_NAMES[date.getDay()];

  return `${year}/${month}/${day}（${dayOfWeek}）`;
}
